// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ButtonUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as IncidentalChargesForm from "./IncidentalChargesForm.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function IncidentalChargesCmp(Props) {
  var currency_symbol = Props.currency_symbol;
  var incidental_charges = Props.incidental_charges;
  var updateIncidentalCharges = Props.updateIncidentalCharges;
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = React.useState(function () {
        return true;
      });
  var updadateAddButtonState = match[1];
  var add_more_incidental_charges_btn_enable = match[0];
  var toggleAddIncidentalChargesButton = function (param) {
    return Curry._1(updadateAddButtonState, (function (param) {
                  return !add_more_incidental_charges_btn_enable;
                }));
  };
  if (add_more_incidental_charges_btn_enable) {
    return React.createElement("div", {
                className: "c-add-incidental-charges-btn-wrapper"
              }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                    buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement("p", {
                                          className: "add-incidental-charges-btn-label"
                                        }, "+ Add Incidental Charges");
                            })
                        }, false, (function (param) {
                            return Curry._1(updadateAddButtonState, (function (param) {
                                          return !add_more_incidental_charges_btn_enable;
                                        }));
                          }), undefined, undefined, undefined, undefined, "add-incidental-charges-btn", undefined, undefined)
                  }));
  }
  var data = state.incident_charges_types;
  if (typeof data === "number") {
    return React.createElement(CircularLoader$Catalyst.make, {});
  }
  switch (data.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement(IncidentalChargesForm.make, {
                    currency_symbol: currency_symbol,
                    incident_charges_types: data._0,
                    incidental_charges: incidental_charges,
                    updateIncidentalCharges: updateIncidentalCharges,
                    toggleAddIncidentalChargesButton: toggleAddIncidentalChargesButton,
                    dispatch: dispatch
                  });
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: data._0
                  });
    
  }
}

var make = IncidentalChargesCmp;

export {
  make ,
  
}
/* react Not a pure module */
